var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCanaryIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C14.0429 0.0107422 12.1681 0.362805 10.4348 1.00593L9.73912 16.0107L10.4347 31.0156C12.1681 31.6587 14.0429 32.0107 16 32.0107C17.9571 32.0107 19.8319 31.6587 21.5652 31.0156L22.2609 16.0107L21.5652 1.00593C19.8319 0.362805 17.9571 0.0107422 16 0.0107422V0.0107422Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0107C32 9.13123 27.658 3.26655 21.5652 1.00586V31.0155C27.658 28.7548 32 22.8901 32 16.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 31.0155V1.00586C4.342 3.26655 0 9.13123 0 16.0107C0 22.8901 4.342 28.7548 10.4348 31.0155Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCanaryIslands);
export default __webpack_public_path__ + "static/media/flag_canary_islands.a82c62081b95c98a8c252fc0b13d7e6c.svg";
export { ForwardRef as ReactComponent };